export const contacts = [
  {
    email: "schoolsub@scmp.com",
    name: "School Subscription",
  },
  {
    email: "littlejournalist@scmp.com",
    name: "Little Journalist",
  },
  {
    email: "postiesevent@scmp.com",
    name: "Edutainment Camp and Event",
  },
];
